import {
  fallbackImage,
  fallbackRichText,
  fallbackText,
  LinkType,
  Prismic,
  PrismicContext,
} from '@landsbankinn/prismic';
import { ArrowButton, Segment } from '@landsbankinn/ui';
import Link from 'next/link';
import React, { useContext } from 'react';
import { ArticleCardGroup } from '../components/card-group/ArticleCardGroup';
import { Card } from '../components/card/Card';

interface FeaturedArticlesContainerField {
  a_article: Prismic.Link & {
    abstract: Prismic.RichText;
    title: Prismic.RichText;
    image: Prismic.Image;
    _meta: any;
  };
  a_image: Prismic.Image;
  a_title: Prismic.RichText;
  a_abstract: Prismic.RichText;
}

interface FeaturedArticlesContainerProps {
  fields: FeaturedArticlesContainerField[];
}

export function FeaturedArticlesContainer({
  fields,
}: FeaturedArticlesContainerProps) {
  const { urlResolver } = useContext(PrismicContext);
  return (
    <Segment paddingBottomMobile={0}>
      <ArticleCardGroup count={fields.length}>
        {fields.map((item, index: number) => {
          const title = fallbackText(item.a_title, item.a_article.title);
          const abstract = fallbackRichText(
            item.a_abstract,
            item.a_article.abstract,
          );
          const image = fallbackImage(item.a_image, item.a_article.image);
          const linkObj = {
            _linkType: LinkType.Document,
            ...(item?.a_article as any),
          };
          const link = Prismic.link(urlResolver, linkObj, title ?? undefined);

          return (
            <Card
              key={index}
              title={Prismic.text(title)}
              description={abstract}
              image={image}
              ar="ar_1_1"
              padding={true}
              backgroundAlt={true}
              action={
                <Link {...link}>
                  <ArrowButton
                    hideText
                    {...link.anchorProps()}
                    title={link.anchorProps().title ?? undefined}
                  />
                </Link>
              }
              link={linkObj}
              percentage={0.33}
            />
          );
        })}
      </ArticleCardGroup>
    </Segment>
  );
}
